import { Controller } from "@hotwired/stimulus"
import AutoNumeric from "autonumeric"

export default class extends Controller {
  connect() {
    new AutoNumeric(this.element, { digitGroupSeparator: " " })
  }
}
